export default "__VITE_ASSET__CsgZm85U__"